import { render, staticRenderFns } from "./CampaignDiscountReview.vue?vue&type=template&id=39f28c69&"
import script from "./CampaignDiscountReview.vue?vue&type=script&lang=js&"
export * from "./CampaignDiscountReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports